"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addRole = addRole;
exports.delRole = delRole;
exports.getInfo = getInfo;
exports.getRoleList = getRoleList;
exports.menuCacheList = menuCacheList;
exports.updateRole = updateRole;
exports.updateRoleStatus = updateRoleStatus;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | A2 [ A2赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.A2.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed A2并不是自由软件，未经许可不能去掉A2相关版权
// +----------------------------------------------------------------------
// | Author: A2 Team <admin@A2.com>
// +----------------------------------------------------------------------

/**
 * 新增
 * @param
 */
function addRole(pram) {
  var data = {
    level: pram.level,
    roleName: pram.roleName,
    status: pram.status,
    rules: pram.rules
  };
  // data.rules = pram.rules.join(',')
  return (0, _request.default)({
    url: '/admin/system/role/save',
    method: 'POST',
    data: data
  });
}

/**
 * 删除
 * @param
 */
function delRole(pram) {
  var data = {
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/system/role/delete',
    method: 'GET',
    params: data
  });
}

/**
 * 详情
 * @param
 */
function getInfo(pram) {
  return (0, _request.default)({
    url: "/admin/system/role/info/".concat(pram),
    method: 'GET'
  });
}

/**
 * 分页列表
 * @param
 */
function getRoleList(pram) {
  var data = {
    createTime: pram.createTime,
    updateTime: pram.updateTime,
    level: pram.level,
    page: pram.page,
    limit: pram.limit,
    roleName: pram.roleName,
    rules: pram.rules,
    status: pram.status
  };
  return (0, _request.default)({
    url: '/admin/system/role/list',
    method: 'get',
    params: data
  });
}

/**
 * 修改
 * @param
 */
function updateRole(pram) {
  var data = {
    id: pram.id,
    roleName: pram.roleName,
    rules: pram.rules,
    status: pram.status
  };
  return (0, _request.default)({
    url: '/admin/system/role/update',
    method: 'post',
    params: {
      id: pram.id
    },
    data: data
  });
}

/**
 * 修改身份状态
 * @param
 */
function updateRoleStatus(pram) {
  return (0, _request.default)({
    url: '/admin/system/role/updateStatus',
    method: 'get',
    params: {
      id: pram.id,
      status: pram.status
    }
  });
}

/**
 * 缓存菜单
 * @param
 */
function menuCacheList(pram) {
  return (0, _request.default)({
    url: '/admin/system/menu/cache/tree',
    method: 'get'
  });
}